
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import ManualPage  from '../../components/ManualPage'

export const metadata = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  metadata
};
const MDXLayout = ({children}) => <ManualPage image="/img/manual.gif">{children}</ManualPage>
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "learning-infrastructure"
    }}>{`Learning Infrastructure`}</h1>
    <h2 {...{
      "id": "discussion-forum"
    }}>{`Discussion Forum`}</h2>
    <p>{`Every course comes with a public forum. Anyone can read this forum, and anyone with a Hyperlink account can post.`}</p>
    <p>{`We also set up each cohort of a course with its own private forum, accessibly only to members of the cohort.`}</p>
    <p>{`Introduce yourself, talk about interests, post questions, and gather feedback — anything you want to ask or share to other learners, the forum is the place to do it.`}</p>
    <p>{`The Hyperlink community is powered by Discourse — modern, open source, highly flexible forum software. If you're new to Discourse, this is a great post covering the basics:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://meta.discourse.org/t/discourse-new-user-guide/96331"
        }}>{`Discourse New User Guide`}</a></li>
    </ul>
    <p>{`Some particularly useful features:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Events:`}</strong>{` Schedule an event right in Discourse — when creating a new post, select "Create event" from the gear icon (upper right in the composer), and input the date. It will then appear both in the topic list, and `}<a parentName="li" {...{
          "href": "https://forum.hyperlink.academy/upcoming-events"
        }}>{`Hyperlink Calendar`}</a>{`.`}</li>
      <li parentName="ul"><strong parentName="li">{`Video Calls with Jitsi:`}</strong>{` We have a quick and easy way to create a video chat in a forum post using Jitsi. Click the video icon (middle of the composer nav bar) to insert a button in your post that will open a video call. Useful in combination with Events!`}</li>
      <li parentName="ul"><strong parentName="li">{`Uploads and Embeds:`}</strong>{` Discourse has great built-in support for uploading images; just drag and drop any image file directly into a post. You can also paste in media links from sites like YouTube and SoundCloud and they'll automatically embed nicely in your post.`}</li>
    </ul>
    <h2 {...{
      "id": "video-calls"
    }}>{`Video Calls`}</h2>
    <p>{`Since Hyperlink courses are run online and we can't all be in the same room, the next best thing is to use regular video calls — for group workshops, one-on-one office hours, presentations, or anything else that calls for a live session. We recommend:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Jitsi:`}</strong>{` high quality, open source, runs totally in-browser on desktop (no download required), and a mobile app available. Pros: it's always free, with no time limits, and we have built-in integration with the forum — when creating a post, just hit the video icon to insert an embedded Jitsi room. Cons: for larger groups, tends to be less stable than Zoom.`}</li>
      <li parentName="ul"><strong parentName="li">{`Zoom:`}</strong>{` popular and performant. Pros: almost everyone knows it; works well even for large groups. Cons: the free tier on Zoom limits group calls to 40 minutes; requires an app download for best results. If you already use Zoom or another video chat app, feel free to use that!`}</li>
    </ul>
    <h2 {...{
      "id": "collaborative-tools"
    }}>{`Collaborative Tools`}</h2>
    <p>{`As noted, Hyperlink courses should be `}<em parentName="p">{`active`}</em>{` — focused on collaboration and feedback with other learners. There are many tools that facilitate this sort of collaboration online, and you should use whichever fit the needs of your course.`}</p>
    <p>{`Here are a few we recommend, all geared toward collaboration, and free for basic use:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://about.gitlab.com/"
        }}>{`GitLab`}</a>{` / `}<a parentName="li" {...{
          "href": "https://github.com/"
        }}>{`GitHub`}</a>{`: shared repositories for code…or other text that might have a use for collaborative version control!`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://about.google/products/"
        }}>{`Google`}</a>{`: Drive, Docs, Sheets, Forms, Slides, Meet and other free apps`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.notion.so/"
        }}>{`Notion`}</a>{`: documents, wikis, to-do lists, database and task management`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.figma.com/"
        }}>{`Figma`}</a>{`: design and prototyping`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.mural.co/"
        }}>{`Mural`}</a>{` / `}<a parentName="li" {...{
          "href": "https://miro.com/"
        }}>{`Miro`}</a>{`: visual workspace, shared whiteboarding`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.are.na/"
        }}>{`Arena`}</a>{`: group bookmarking, great for collecting resources and sharing ideas`}</li>
    </ul>
    <h2 {...{
      "id": "hyperlink-website"
    }}>{`Hyperlink Website`}</h2>
    <p>{`The Hyperlink platform itself is open source software. You can `}<a parentName="p" {...{
        "href": "https://gitlab.com/jaredpereira/hyperlink-academy"
      }}>{`view the source code`}</a>{` and submit changes if you find a bug! `}</p>
    <p>{`See the README in the linked repo for more technical details about the site.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;